export const DRAFT_STATUSES = ['open', 'draft'];
export const FINAL_STATUSES = [
  'cancelled',
  'cancel',
  'rejected',
  'approved',
  'leave approved',
  'collected',
  'salary ready',
  'salary & ticket ready',
  'issued',
  'resumption approved',
  'ta mapping pending',
  'issued to employee',
  'email configured',
  'user-created',
];
